import colors from "../../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const ResetPasswordFormStyle = makeStyles((theme) => ({
	paper: {
		paddingTop: theme.spacing(14),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	headerAvatar: {
		backgroundColor: colors.primary,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		color: colors.white,
		fontWeight: "bold",
		"&:hover": {
			backgroundColor: colors.darkCrimsonRed,
		},
	},
	loaderContainer: {
		paddingTop: "10px",
	},
	loader: {
		height: "30px",
	},
	smallSeperator: {
		display: "none",
		[theme.breakpoints.down("sm")]: {
			display: "block",
		},
	},
	normalSeperator: {
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	passwordPolicy: {
		fontSize: "12px",
		padding: "4px 0",
	},
	filledPasswordPolicy: {
		color: colors.brightGreen,
	},
	pendingPasswordPolicy: {
		color: colors.white,
	},
	invalidLinkBody: {
		marginTop: "1rem",
		textAlign: "justify",
	},
	invalidLinkBody2: {
		marginTop: "0.5rem",
		textAlign: "justify",
	},
}));

export default ResetPasswordFormStyle;
